import { Injectable } from '@angular/core';
import { IZippyId, parseZippyName, subject, ZippyEventType } from '@df/legacy/ui/zippy/zippy.abstract';

@Injectable({
    providedIn: 'root'
})
export class ZippyService {
    /**
     * Open zippy
     */
    open(zippyId: string | string[] | IZippyId) {
        subject.next({
            id: this.toZippyId(zippyId),
            type: ZippyEventType.open
        });
    }

    /**
     * Close zippy
     */
    close(zippyId: string | string[] | IZippyId) {
        subject.next({
            id: this.toZippyId(zippyId),
            type: ZippyEventType.close
        });
    }

    closeAll(zippyId: string | string[]) {
        subject.next({
            id: this.toZippyGroup(zippyId),
            type: ZippyEventType.close
        });
    }

    /**
     * Covnert to zippy id
     */
    toZippyId(name: string | (string | number)[] | IZippyId): IZippyId {
        if (typeof name == 'object' && !Array.isArray(name)) {
            return name;
        }
        return parseZippyName(name);
    }
    /**
     * Covnert to zippy id
     */
    private toZippyGroup(name: string | (string | number)[]): IZippyId {
        const id = parseZippyName(name);
        if (id.group) {
            id.isGroup = true;
        }
        return id;
    }
}
